<template>
  <div class="shop">
    <span class="title">主图</span>
    <div class="box">
      <img v-for="(item, index) of imgList" :key="index" :src="item.img_url" alt="" />
    </div>
    <span class="title">详情</span>
    <div class="box">
      <img v-for="(item, index) of detailList" :key="index" :src="item.goods_detail" alt="" />
    </div>
    <span class="title">规格</span>
    <el-table
      :data="tableData"
      style="width: 100%"
      max-height="610"
      border
      class="infotable"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="规格名称" prop="mod_name"></el-table-column>
      <el-table-column label="进价" prop="market_price"></el-table-column>
      <el-table-column label="售价" prop="discount_price"></el-table-column>
      <el-table-column label="共享收益" prop="share_income"> </el-table-column>
    </el-table>
    <span class="title">核销地点</span>
    <div class="box1">
      <span>{{address}}</span>
    </div>
  </div>
</template>

<script>
import { getHotGoodsDetail } from '@/api/nearbyHot'
export default {
  data() {
    return {
      imgList: [],
      detailList: [],
      tableData: [],
      address:''
    }
  },
  created() {
    if (this.$route.query.goods_id) {
      this.getData(this.$route.query.goods_id)
    }
  },
  mounted() {},
  methods: {
    async getData(goods_id) {
      console.log(goods_id)
      let res = await getHotGoodsDetail({ goods_id })
      if (res.code === 10000) {
        this.imgList = res.data.img_lsit
        this.detailList = res.data.extend_lsit
        this.tableData = res.data.sku_lsit
        this.address = res.data.sign_address
      } else {
        this.$message.error(res.message)
      }
    },

    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    },
  },
}
</script>
<style lang="scss" scoped>
.box{
  margin: 20px 0;
  display: flex;
  align-content: center;
  flex-wrap: wrap;
  img{
    width: 300px;
    height: 300px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
.box1{
  margin: 20px 0;
  color: #333333;
  font-size: 15px;
}
.shop {
  padding: 20px;

  .title {
    color: #333333;
    font-size: 18px;
    margin-right: 12px;
    margin-top: 4px;
  }
  .status {
    color: #f4222d;
  }
  .loginfor {
    cursor: pointer;
  }
  .infotable {
    margin: 20px 0;
  }

  .remark {
    padding: 20px;
    .note {
      color: #666666;
      margin-bottom: 12px;
    }
    .btn-info {
      text-align: center;
    }
  }
  .block {
    padding: 20px;
  }
}
</style>
